// extracted by mini-css-extract-plugin
export default {"tab":"tab_tab__7J1I8","tabActive":"tab_tabActive__529H5"};